module.exports = __webpack_public_path__ + "img/SketchPng6f890c4f2068a38f74974885cadba83005f93c9f5f47ec53bb19f0fc131b03ab.6a80e9d4.png";